<script lang="ts">
	import { LuxedoRPC } from "luxedo-rpc"
	import type { BundledCalibrationData } from "luxedo-rpc/src/types/BundledTypes"
	import moment from "moment"

	import { Toast } from "toaster"
	import { openConfirmOverlay, openImageOverlay } from "overlay"
	import { initContextMenu, type ContextMenuOptions } from "context-menu"

	import * as css from "../../user/user-view/UserRow.module.css"
	import { downloadCalImages } from "../../../../modules/CalUtil"

	interface Props {
		trackedCals?: Array<BundledCalibrationData>
		updateTrackedCals: () => void
	}

	let { trackedCals = [], updateTrackedCals }: Props = $props()

	async function deleteCalibration(cal: BundledCalibrationData) {
		try {
			await LuxedoRPC.api.admin.tracked_cali_delete(cal.id)
			Toast.success("Calibration deleted.")
			updateTrackedCals()
		} catch (e) {
			Toast.error("Unable to delete calibration.")
			console.error("Unable to delete calibration.", e)
		}
	}

	function getCalStatus(calFailed: number) {
		console.log(calFailed)
		return {
			[-1]: "Unresolved",
			0: "Success",
			1: "Failure",
			2: "Canceled",
		}[calFailed ?? 1]
	}

	function showCalImages(cal: BundledCalibrationData) {
		openImageOverlay(cal.s3urls.images, {
			heading: `Calibration ${cal.id}`,
		})
	}

	async function viewMetadata(cal: BundledCalibrationData) {
		try {
			const res = await fetch(cal.s3urls.metadata, {
				mode: "cors",
				headers: {
					"Access-Control-Allow-Origin": "*",
				},
			})
			const data = await res.json()
			console.warn(`Metadata for calibration #${cal.id}:`, data)
			Toast.success("To view metadata, open the console (F12).")
		} catch (e) {
			Toast.error(`Unable to retreive metadata for calibration #${cal.id}`)
			console.error("Error getting calibration metadata.", e)
		}
	}

	function onCalClick(cal: BundledCalibrationData, e: MouseEvent) {
		const ctxMenuOpts: ContextMenuOptions = [
			{ title: "View Images", onClick: () => showCalImages(cal) },
			{ title: "Download Images", onClick: () => downloadCalImages(cal) },
			{ title: "Metadata", onClick: () => viewMetadata(cal) },
			{
				title: "Delete",
				onClick: () =>
					openConfirmOverlay(
						{
							prompt: "Are you sure you want to delete this calibration attempt?",
							invertWarning: true,
							buttons: {
								confirm: {
									text: "Yes",
									onClick: () => deleteCalibration(cal),
								},
							},
						},
						{ heading: "Delete Calibration" }
					),
			},
		]
		const ctxMenuHandler = initContextMenu(ctxMenuOpts)
		ctxMenuHandler(e)
	}
</script>

<div class={css.info}>
	<h2>Calibrations</h2>
	{#if trackedCals.length > 0}
		<table>
			<thead>
				<tr>
					<th> ID </th>
					<th>Status</th>
					<th> Date </th>
					<th>Error Code</th>
					<th>Device ID</th>
				</tr>
			</thead>
			<tbody>
				{#each trackedCals as cal}
					<tr class={`${css.row} cal-row`} onclick={(e) => onCalClick(cal, e)}>
						<td>{cal.id}</td>
						<td>{getCalStatus(cal.failed)}</td>
						<td>{moment(cal.run_time).format("MM/DD/YY hh:mm a")}</td>
						<td>{cal.failure_code}</td>
						<td>{cal.dev_id}</td>
					</tr>
				{/each}
			</tbody>
		</table>
	{/if}
</div>

<style>
	.cal-row td:last-of-type {
		width: unset;
	}
</style>
